import React from 'react';
import localization from 'assets/localization/localization';
import './cardSection.css'
const CardSection = ({ children, title, status, remove, removeIt }) => {
  return (
<div className="card">
  <div className="card-header">
  {title} {status && (
           <div className="panel_Design">
          <span
            className={`status-td ${status === 'In Progress'
                ? `warm`
                : status === 'Not Started'
                  ? 'cold'
                  : status === 'Completed'
                    ? 'completed'
                    : ''
              }`}
          >
            {status}
          </span>
          </div>
         
        )}
        {remove && (
          <a
            className="field-remove"
            onClick={() => {
              removeIt(true);
            }}
          >
            {localization.remove}
          </a>
        )}
  </div>
  <div className="card-body">
    {children}
  </div>
</div>

  );
};

export default CardSection;
